export interface CurlingClub {
  id?: string;
  name: string;
  city: string;
  country: string;
}

export const curlingClubs: CurlingClub[] = [
  // Canada - Major Clubs
  { name: "Granite Curling Club", city: "Seattle", country: "USA" },
  { name: "Calgary Curling Club", city: "Calgary", country: "Canada" },
  { name: "Glencoe Club", city: "Calgary", country: "Canada" },
  { name: "Royal Canadian Curling Club", city: "Toronto", country: "Canada" },
  { name: "Avonair Curling Club", city: "Edmonton", country: "Canada" },
  { name: "Saville Community Sports Centre", city: "Edmonton", country: "Canada" },
  { name: "Mayfield Curling Club", city: "Edmonton", country: "Canada" },
  { name: "Edmonton Granite Curling Club", city: "Edmonton", country: "Canada" },
  { name: "Ottewell Curling Club", city: "Edmonton", country: "Canada" },
  { name: "Crestwood Curling Club", city: "Edmonton", country: "Canada" },
  { name: "The Granite Club", city: "Toronto", country: "Canada" },
  { name: "Leaside Curling Club", city: "Toronto", country: "Canada" },
  { name: "High Park Club", city: "Toronto", country: "Canada" },
  { name: "Scarboro Golf & Country Club", city: "Toronto", country: "Canada" },
  { name: "Royal Montreal Curling Club", city: "Montreal", country: "Canada" },
  { name: "Mount Royal Curling Club", city: "Montreal", country: "Canada" },
  { name: "Town of Mount Royal Curling Club", city: "Montreal", country: "Canada" },
  { name: "Vancouver Curling Club", city: "Vancouver", country: "Canada" },
  { name: "Hollyburn Country Club", city: "West Vancouver", country: "Canada" },
  { name: "Royal City Curling Club", city: "New Westminster", country: "Canada" },
  { name: "Kelowna Curling Club", city: "Kelowna", country: "Canada" },
  { name: "Vernon Curling Club", city: "Vernon", country: "Canada" },
  { name: "Penticton Curling Club", city: "Penticton", country: "Canada" },
  { name: "Nutana Curling Club", city: "Saskatoon", country: "Canada" },
  { name: "Sutherland Curling Club", city: "Saskatoon", country: "Canada" },
  { name: "Tartan Curling Club", city: "Regina", country: "Canada" },
  { name: "Assiniboine Memorial Curling Club", city: "Winnipeg", country: "Canada" },
  { name: "Fort Rouge Curling Club", city: "Winnipeg", country: "Canada" },
  { name: "Deer Lodge Curling Club", city: "Winnipeg", country: "Canada" },
  { name: "St. Vital Curling Club", city: "Winnipeg", country: "Canada" },
  { name: "Charlottetown Curling Club", city: "Charlottetown", country: "Canada" },
  { name: "Silver Fox Curling & Yacht Club", city: "Summerside", country: "Canada" },
  { name: "Halifax Curling Club", city: "Halifax", country: "Canada" },
  { name: "Mayflower Curling Club", city: "Halifax", country: "Canada" },
  { name: "Capital Winter Club", city: "Fredericton", country: "Canada" },
  { name: "Thistle St. Andrews Curling Club", city: "Saint John", country: "Canada" },
  { name: "RE/MAX Centre", city: "Waterloo", country: "Canada" },
  { name: "Kitchener-Waterloo Granite Club", city: "Waterloo", country: "Canada" },
  { name: "Brampton Curling Club", city: "Brampton", country: "Canada" },
  { name: "Oshawa Curling Club", city: "Oshawa", country: "Canada" },
  { name: "Whitby Curling Club", city: "Whitby", country: "Canada" },
  { name: "Hamilton Thistle Curling Club", city: "Hamilton", country: "Canada" },
  { name: "Dundas Curling Club", city: "Dundas", country: "Canada" },
  { name: "Strathcona Curling Club", city: "Calgary", country: "Canada" },
  { name: "Cochrane Curling Club", city: "Cochrane", country: "Canada" },
  { name: "Canmore Curling Club", city: "Canmore", country: "Canada" },
  { name: "Red Deer Curling Club", city: "Red Deer", country: "Canada" },
  { name: "Lethbridge Curling Club", city: "Lethbridge", country: "Canada" },
  { name: "Medicine Hat Curling Club", city: "Medicine Hat", country: "Canada" },

  // USA
  { name: "Granite Curling Club", city: "Seattle", country: "USA" },
  { name: "Seattle Curling Club", city: "Seattle", country: "USA" },
  { name: "St. Paul Curling Club", city: "St. Paul", country: "USA" },
  { name: "Frogtown Curling Club", city: "St. Paul", country: "USA" },
  { name: "Duluth Curling Club", city: "Duluth", country: "USA" },
  { name: "Four Seasons Curling Club", city: "Blaine", country: "USA" },
  { name: "Madison Curling Club", city: "Madison", country: "USA" },
  { name: "Milwaukee Curling Club", city: "Cedarburg", country: "USA" },
  { name: "Chicago Curling Club", city: "Northbrook", country: "USA" },
  { name: "Exmoor Country Club", city: "Highland Park", country: "USA" },
  { name: "Windy City Curling Club", city: "Villa Park", country: "USA" },
  { name: "Detroit Curling Club", city: "Ferndale", country: "USA" },
  { name: "Ann Arbor Curling Club", city: "Ann Arbor", country: "USA" },
  { name: "Traverse City Curling Club", city: "Traverse City", country: "USA" },
  { name: "Bemidji Curling Club", city: "Bemidji", country: "USA" },
  { name: "Broomstones Curling Club", city: "Wayland", country: "USA" },
  { name: "Cape Cod Curling Club", city: "Falmouth", country: "USA" },
  { name: "Petersham Curling Club", city: "Petersham", country: "USA" },
  { name: "Schenectady Curling Club", city: "Schenectady", country: "USA" },
  { name: "Nashua Country Club", city: "Nashua", country: "USA" },
  { name: "Utica Curling Club", city: "Whitesboro", country: "USA" },
  { name: "Philadelphia Curling Club", city: "Paoli", country: "USA" },
  { name: "Ardsley Curling Club", city: "Ardsley-on-Hudson", country: "USA" },
  { name: "Nutmeg Curling Club", city: "Bridgeport", country: "USA" },
  { name: "Potomac Curling Club", city: "Laurel", country: "USA" },
  { name: "Triangle Curling Club", city: "Durham", country: "USA" },
  { name: "Denver Curling Club", city: "Denver", country: "USA" },
  { name: "Evergreen Curling Club", city: "Evergreen", country: "USA" },
  { name: "Broadmoor Curling Club", city: "Colorado Springs", country: "USA" },
  { name: "Utah Olympic Oval", city: "Kearns", country: "USA" },
  { name: "Ogden Curling Club", city: "Ogden", country: "USA" },
  { name: "Las Vegas Curling Club", city: "Las Vegas", country: "USA" },
  { name: "San Francisco Bay Area Curling Club", city: "San Jose", country: "USA" },
  { name: "Hollywood Curling Club", city: "Los Angeles", country: "USA" },
  { name: "Boise Curling Club", city: "Boise", country: "USA" },
  { name: "McCall Curling Club", city: "McCall", country: "USA" },

  // Scotland
  { name: "Royal Caledonian Curling Club", city: "Edinburgh", country: "Scotland" },
  { name: "Murrayfield Curling Club", city: "Edinburgh", country: "Scotland" },
  { name: "Gogar Park Curling Club", city: "Edinburgh", country: "Scotland" },
  { name: "Stirling Curling Club", city: "Stirling", country: "Scotland" },
  { name: "Perth Curling Club", city: "Perth", country: "Scotland" },
  { name: "Dundee Ice Arena", city: "Dundee", country: "Scotland" },
  { name: "Aberdeen Curling Club", city: "Aberdeen", country: "Scotland" },
  { name: "Inverness Curling Club", city: "Inverness", country: "Scotland" },
  { name: "Greenacres Curling Club", city: "Howwood", country: "Scotland" },
  { name: "Hamilton Curling Club", city: "Hamilton", country: "Scotland" },
  { name: "Braehead Curling Club", city: "Renfrew", country: "Scotland" },
  { name: "Forfar Curling Club", city: "Forfar", country: "Scotland" },
  { name: "Stranraer Curling Club", city: "Stranraer", country: "Scotland" },

  // Sweden
  { name: "Karlstads Curlingklubb", city: "Karlstad", country: "Sweden" },
  { name: "Skellefteå Curling Club", city: "Skellefteå", country: "Sweden" },
  { name: "Sundsvalls Curlingklubb", city: "Sundsvall", country: "Sweden" },
  { name: "Östersunds Curlingklubb", city: "Östersund", country: "Sweden" },
  { name: "Gävle Curling Club", city: "Gävle", country: "Sweden" },
  { name: "Uppsala Curling Club", city: "Uppsala", country: "Sweden" },
  { name: "Stockholms Curling Club", city: "Stockholm", country: "Sweden" },
  { name: "Sollentuna Curling Club", city: "Sollentuna", country: "Sweden" },
  { name: "Göteborg Curling Club", city: "Göteborg", country: "Sweden" },
  { name: "Malmö Curlingklubb", city: "Malmö", country: "Sweden" },

  // Switzerland
  { name: "Curling Club Bern", city: "Bern", country: "Switzerland" },
  { name: "Curling Club Basel", city: "Basel", country: "Switzerland" },
  { name: "Curling Club Zürich", city: "Zürich", country: "Switzerland" },
  { name: "Curling Club Geneva", city: "Geneva", country: "Switzerland" },
  { name: "Curling Club Davos", city: "Davos", country: "Switzerland" },
  { name: "Curling Club St. Moritz", city: "St. Moritz", country: "Switzerland" },
  { name: "Curling Club Gstaad", city: "Gstaad", country: "Switzerland" },
  { name: "Curling Club Lausanne", city: "Lausanne", country: "Switzerland" },
  { name: "Curling Club Winterthur", city: "Winterthur", country: "Switzerland" },
  { name: "Curling Club Zug", city: "Zug", country: "Switzerland" },

  // Norway
  { name: "Oslo Curling Club", city: "Oslo", country: "Norway" },
  { name: "Snarøya Curling Club", city: "Oslo", country: "Norway" },
  { name: "Bergen Curling Club", city: "Bergen", country: "Norway" },
  { name: "Trondheim Curling Club", city: "Trondheim", country: "Norway" },
  { name: "Stavanger Curling Club", city: "Stavanger", country: "Norway" },
  { name: "Oppdal Curling Club", city: "Oppdal", country: "Norway" },
  { name: "Lillehammer Curling Club", city: "Lillehammer", country: "Norway" },

  // Denmark
  { name: "Copenhagen Curling Club", city: "Copenhagen", country: "Denmark" },
  { name: "Hvidovre Curling Club", city: "Hvidovre", country: "Denmark" },
  { name: "Aalborg Curling Club", city: "Aalborg", country: "Denmark" },

  // Finland
  { name: "Helsinki Curling Club", city: "Helsinki", country: "Finland" },
  { name: "Turku Curling Club", city: "Turku", country: "Finland" },
  { name: "Tampere Curling Club", city: "Tampere", country: "Finland" },

  // Germany
  { name: "Curling Club Hamburg", city: "Hamburg", country: "Germany" },
  { name: "Curling Club München", city: "Munich", country: "Germany" },
  { name: "Curling Club Berlin", city: "Berlin", country: "Germany" },
  { name: "Curling Club Frankfurt", city: "Frankfurt", country: "Germany" },
  { name: "Füssen Curling Club", city: "Füssen", country: "Germany" },
  { name: "Garmisch Curling Club", city: "Garmisch-Partenkirchen", country: "Germany" },

  // Netherlands
  { name: "Curling Club Amsterdam", city: "Amsterdam", country: "Netherlands" },
  { name: "Curling Club Rotterdam", city: "Rotterdam", country: "Netherlands" },
  { name: "Zoetermeer Curling Club", city: "Zoetermeer", country: "Netherlands" },

  // Japan
  { name: "Karuizawa Curling Club", city: "Karuizawa", country: "Japan" },
  { name: "Nagano Curling Club", city: "Nagano", country: "Japan" },
  { name: "Kitami Curling Club", city: "Kitami", country: "Japan" },
  { name: "Sapporo Curling Club", city: "Sapporo", country: "Japan" },
  { name: "Tokoro Curling Club", city: "Kitami", country: "Japan" },

  // China
  { name: "Beijing Curling Club", city: "Beijing", country: "China" },
  { name: "Harbin Curling Club", city: "Harbin", country: "China" },
  { name: "Qingdao Curling Club", city: "Qingdao", country: "China" },

  // South Korea
  { name: "Seoul Curling Club", city: "Seoul", country: "South Korea" },
  { name: "Gangneung Curling Centre", city: "Gangneung", country: "South Korea" },
  { name: "Uiseong Curling Club", city: "Uiseong", country: "South Korea" },

  // England
  { name: "Fenton's Rink", city: "Tunbridge Wells", country: "England" },
  { name: "Curl Aberdeen", city: "Aberdeen", country: "England" },
  { name: "Ice Sheffield", city: "Sheffield", country: "England" },
  { name: "Dumfries Ice Bowl", city: "Dumfries", country: "England" },

  // Australia
  { name: "Australian Ice Curling Federation", city: "Sydney", country: "Australia" },
  { name: "Melbourne Curling Club", city: "Melbourne", country: "Australia" },

  // New Zealand
  { name: "New Zealand Curling Association", city: "Dunedin", country: "New Zealand" },
  { name: "Naseby Curling Club", city: "Naseby", country: "New Zealand" },

  // Italy
  { name: "Curling Club Cortina", city: "Cortina d'Ampezzo", country: "Italy" },
  { name: "Curling Club Pinerolo", city: "Pinerolo", country: "Italy" },
  { name: "Curling Club Milano", city: "Milan", country: "Italy" },

  // Austria
  { name: "Curling Club Vienna", city: "Vienna", country: "Austria" },
  { name: "Curling Club Kitzbühel", city: "Kitzbühel", country: "Austria" },

  // Czech Republic
  { name: "Prague Curling Club", city: "Prague", country: "Czech Republic" },
  { name: "Brno Curling Club", city: "Brno", country: "Czech Republic" },

  // Russia
  { name: "Moscow Curling Club", city: "Moscow", country: "Russia" },
  { name: "St. Petersburg Curling Club", city: "St. Petersburg", country: "Russia" },

  // France
  { name: "Lyon Curling Club", city: "Lyon", country: "France" },
  { name: "Paris Curling Club", city: "Paris", country: "France" },
  { name: "Chamonix Curling Club", city: "Chamonix", country: "France" },
].sort((a, b) => a.name.localeCompare(b.name));